"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Spinner_1 = require("office-ui-fabric-react/lib/Spinner");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var styles = require('./OptionsPaneLoading.scss');
var OptionsPaneLoading = /** @class */ (function (_super) {
    tslib_1.__extends(OptionsPaneLoading, _super);
    function OptionsPaneLoading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OptionsPaneLoading.prototype.render = function () {
        return (React.createElement("div", { className: styles.messageContainer },
            React.createElement("div", null,
                React.createElement(Spinner_1.Spinner, { type: Spinner_1.SpinnerType.large })),
            React.createElement("div", { className: styles.messageText }, owa_options_strings_1.default.optionsFull_subCategory_loading)));
    };
    return OptionsPaneLoading;
}(React.Component));
exports.default = OptionsPaneLoading;
//# sourceMappingURL=OptionsPaneLoading.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/view/owa-options-view/lib/components/full/OptionsPaneLoading.js
// module id = 5307
// module chunks = 2